import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { NavigationBar } from "components/common/NavigationBar";
import type { ObjectNavigationBarProps } from "./types";

export const ObjectNavigationBar = ({
  canPrev,
  canNext,
  onPrev,
  onNext,
  onSelectIndex,
  selectedIndex,
  total,
  className,
}: ObjectNavigationBarProps) => {
  const { t } = useTranslation();

  if (selectedIndex < 0) {
    return null;
  }

  return (
    <div
      className={clsx(
        "absolute bottom-3 left-1/2 -translate-x-1/2 z-20",
        "rounded-lg border bg-white/95 backdrop-blur px-1.5 py-1 shadow-sm",
        className,
      )}
      onMouseDown={(event) => event.stopPropagation()}
      onTouchStart={(event) => event.stopPropagation()}
    >
      <NavigationBar
        selectedIndex={selectedIndex}
        total={total}
        canPrev={canPrev}
        canNext={canNext}
        onPrev={onPrev}
        onNext={onNext}
        onSelectIndex={onSelectIndex}
        prevLabel={t("common.prev")}
        nextLabel={t("common.next")}
      />
    </div>
  );
};
